import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/images/fzkg.png';
import _imports_1 from '../../assets/images/fzyp.png';
import _imports_2 from '../../assets/images/yjyzg.png';
import _imports_3 from '../../assets/images/fzsq.png';
import _imports_4 from '../../assets/images/yaochenglogo.png';
import _imports_5 from '../../assets/images/index2.png';
import _imports_6 from '../../assets/images/yaochenglogo3.png';
import _imports_7 from '../../assets/images/gupiaologo.png';
const _withScopeId = n => (_pushScopeId("data-v-2080cd21"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "index-view"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h1", null, "方舟控股大数据中心")], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "方舟控股"), /*#__PURE__*/_createElementVNode("p", null, "方舟中台生态大数据")], -1));
const _hoisted_5 = [_hoisted_3, _hoisted_4];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "方舟优品"), /*#__PURE__*/_createElementVNode("p", null, "企业数字化产销平台")], -1));
const _hoisted_8 = [_hoisted_6, _hoisted_7];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "壹加壹数商"), /*#__PURE__*/_createElementVNode("p", null, "数字门店为实体赋能")], -1));
const _hoisted_11 = [_hoisted_9, _hoisted_10];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "方舟数企"), /*#__PURE__*/_createElementVNode("p", null, "全球企业数字化转型")], -1));
const _hoisted_14 = [_hoisted_12, _hoisted_13];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "药城大数据"), /*#__PURE__*/_createElementVNode("p", null, "药城大数据平台入口")], -1));
const _hoisted_17 = [_hoisted_15, _hoisted_16];
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "互医大数据"), /*#__PURE__*/_createElementVNode("p", null, "互联网医院大数据平台入口")], -1));
const _hoisted_20 = [_hoisted_18, _hoisted_19];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "药房大数据"), /*#__PURE__*/_createElementVNode("p", null, "药房大数据平台入口")], -1));
const _hoisted_23 = [_hoisted_21, _hoisted_22];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "股票资讯"), /*#__PURE__*/_createElementVNode("p", null, "股票资讯平台入口")], -1));
const _hoisted_26 = [_hoisted_24, _hoisted_25];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", null, [_createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.goNumber && _ctx.goNumber(...args))
  }, _hoisted_5), _createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = (...args) => _ctx.goYp && _ctx.goYp(...args))
  }, _hoisted_8), _createElementVNode("div", {
    onClick: _cache[2] || (_cache[2] = (...args) => _ctx.goYjy && _ctx.goYjy(...args))
  }, _hoisted_11), _createElementVNode("div", {
    onClick: _cache[3] || (_cache[3] = (...args) => _ctx.goFzsq && _ctx.goFzsq(...args))
  }, _hoisted_14)]), _createElementVNode("div", null, [_createElementVNode("div", {
    onClick: _cache[4] || (_cache[4] = (...args) => _ctx.goRealtime && _ctx.goRealtime(...args))
  }, _hoisted_17), _createElementVNode("div", {
    onClick: _cache[5] || (_cache[5] = (...args) => _ctx.goInternet && _ctx.goInternet(...args))
  }, _hoisted_20), _createElementVNode("div", {
    onClick: _cache[6] || (_cache[6] = (...args) => _ctx.goSearch && _ctx.goSearch(...args))
  }, _hoisted_23), _createElementVNode("div", {
    onClick: _cache[7] || (_cache[7] = (...args) => _ctx.goGuPiao && _ctx.goGuPiao(...args))
  }, _hoisted_26)])]);
}